'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _util = require('../util');

var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

// install v-link, which provides navigation support for
// HTML5 history mode

exports['default'] = function (Vue) {

  var _ = Vue.util;

  Vue.directive('link', {

    bind: function bind() {
      var _this = this;

      var vm = this.vm;
      /* istanbul ignore if */
      if (!vm.$route) {
        (0, _util.warn)('v-link can only be used inside a ' + 'router-enabled app.');
        return;
      }
      var router = vm.$route.router;
      this.handler = function (e) {
        // don't redirect with control keys
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        // don't redirect when preventDefault called
        if (e.defaultPrevented) return;
        // don't redirect on right click
        if (e.button !== 0) return;

        if (_this.el.tagName === 'A' || e.target === _this.el) {
          // v-link on <a v-link="'path'">
          e.preventDefault();
          if (_this.destination != null) {
            router.go(_this.destination, _this.replace === true);
          }
        } else {
          // v-link delegate on <div v-link>
          var el = e.target;
          while (el && el.tagName !== 'A' && el !== _this.el) {
            el = el.parentNode;
          }
          if (!el || el.tagName !== 'A' || !el.href) return;
          if (sameOrigin(el)) {
            e.preventDefault();
            router.go(el.pathname);
          }
        }
      };
      this.el.addEventListener('click', this.handler);
      // manage active link class
      this.unwatch = vm.$watch('$route.path', _.bind(this.updateClasses, this));
    },

    update: function update(path) {
      var router = this.vm.$route.router;
      this.replace = typeof path === 'object' ? path.replace : false;
      path = router._normalizePath(path);
      this.destination = path;
      this.activeRE = path ? new RegExp('^' + path.replace(regexEscapeRE, '\\$&') + '\\b') : null;
      this.updateClasses(this.vm.$route.path);
      var isAbsolute = path.charAt(0) === '/';
      // do not format non-hash relative paths
      var href = router.mode === 'hash' || isAbsolute ? router.history.formatPath(path) : path;
      if (this.el.tagName === 'A') {
        if (href) {
          this.el.href = href;
        } else {
          this.el.removeAttribute('href');
        }
      }
    },

    updateClasses: function updateClasses(path) {
      var el = this.el;
      var dest = this.destination;
      var router = this.vm.$route.router;
      var activeClass = router._linkActiveClass;
      var exactClass = activeClass + '-exact';
      if (this.activeRE && this.activeRE.test(path) && path !== '/') {
        _.addClass(el, activeClass);
      } else {
        _.removeClass(el, activeClass);
      }
      if (path === dest) {
        _.addClass(el, exactClass);
      } else {
        _.removeClass(el, exactClass);
      }
    },

    unbind: function unbind() {
      this.el.removeEventListener('click', this.handler);
      this.unwatch && this.unwatch();
    }
  });

  function sameOrigin(link) {
    return link.protocol === location.protocol && link.hostname === location.hostname && link.port === location.port;
  }
};

module.exports = exports['default'];